export type Character = 'BUDDY' | 'PIPI' | 'BONI'

export interface UserSummary {
  id: string
  email: string | null
  nickname: string | null
  language: string
  oauth_provider: string
  character: Character | null
  created_at: string
  last_active_at: string | null
  message_count: number
  thread_count: number
}

// UserInfo from backend (used in UserDetailResponse)
export interface UserInfo {
  id: string
  email: string | null
  nickname: string | null
  language: string
  oauth_provider: string
  created_at: string
}

export interface GreenmateInfo {
  id: number
  greenmate_type: string
  name: string | null
  created_at: string
}

export interface UserStats {
  total_threads: number
  active_threads: number
  total_messages: number
  user_messages: number
  assistant_messages: number
  first_message_at: string | null
  last_message_at: string | null
  avg_messages_per_thread: number
  days_since_last_activity: number
}

// Backend returns this structure for GET /api/users/{id}
export interface UserDetailResponse {
  user: UserInfo
  greenmate: GreenmateInfo | null
  stats: UserStats
}

export const CHARACTER_INFO: Record<Character, { name: string; emoji: string }> = {
  BUDDY: { name: 'Buddy', emoji: '🐻' },
  PIPI: { name: 'Pipi', emoji: '🐰' },
  BONI: { name: 'Boni', emoji: '🐣' },
}
